import { PAYWALL_VISIBILITY } from "../constants/PayWall";

const initialState = {
  paywallVisibility: false,
};

const payWall = (state = initialState, action) => {
  switch (action.type) {
    case PAYWALL_VISIBILITY:
      return {
        ...state,
        paywallVisibility: action.payload,
      };
    default:
      return state;
  }
};

export default payWall;
